module.exports = __webpack_public_path__ + "fonts/ralewaysemibold.496b133.ttf";